import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-state-warning",
  "use": "icon-state-warning-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-state-warning\">\r\n<style type=\"text/css\">\r\n\t#icon-state-warning .st0{fill:#E6A23C;}\r\n\t#icon-state-warning .st1{fill:#A56B20;}\r\n</style>\r\n<path class=\"st0\" d=\"M172.7,0H0l200,200V27.2C200,12.2,187.8,0,172.7,0z\" />\r\n<path class=\"st1\" d=\"M177.3,177.2v22.7H200L177.3,177.2z M0.5,0.2v23.2h23.2L0.5,0.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol